// childDismissalApi.js

import apiClient from '../../../../../services/apiClient';
import { createNewDoc_KG, uploadFile } from '../DocumentsList/actions';

export const childDismissalApi = {
  // Создание документа садика с приказом
  async createDismissalDocument(kgId, documentData) {
    const docData = {
      target_id: kgId,
      type: 'dismissal_order', // специальный тип для приказов на выбытие
      name: documentData.documentName,
      description: `Наказ про вибуття дитини. ${documentData.reason}`
    };
    
    const result = await createNewDoc_KG(docData);
    return result.data; // возвращаем созданный документ с ID
  },

  // Загрузка файла в документ
  async uploadDismissalFile(docId, file) {
    const fileInfo = {
      doc_id: docId,
      name: file.name,
      mtype: file.type,
      length: file.size,
      date: new Date().toISOString()
    };

    // Конвертируем base64 в ArrayBuffer для загрузки
    const fileBuffer = base64ToArrayBuffer(file.file);
    const result = await uploadFile(fileInfo, fileBuffer);
    return result;
  },

  // Отправка данных о выбытии с ссылкой на документ
  async submitDismissalData(kgId, childId, dismissalData, documentId) {
    const data = {
      kgId,
      childId,
      documentId, // ID созданного документа
      orderNumber: dismissalData.orderNumber,
      orderDate: dismissalData.orderDate,
      reason: dismissalData.reason,
      dismissalDate: dismissalData.dismissalDate
    };
    
    return await apiClient.post(`kindergartens/${kgId}/child_dismissal`, data);
  }
};

// Вспомогательная функция для конвертации base64 в ArrayBuffer
function base64ToArrayBuffer(base64) {
  const binaryString = atob(base64.split(',')[1]);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}